// O CALENDÁRIO: em que dia cada coisa acontece.
//
// A temporada 1 começa em outubro de 2026 e vai até junho, como uma temporada
// de basquete de verdade. Rodada 12 não diz nada a ninguém; "sáb, 15 de
// novembro" diz.
//
// ⚠️ Tudo aqui é DERIVADO de `season` e `round` — nada é guardado no save. Uma
// data por partida seriam milhares de campos a mais no arquivo, e o save do 38
// Brasil já mostrou onde isso termina. A conta é barata e o resultado é sempre
// o mesmo para a mesma rodada.

/** A temporada 1 é a de 2026/27. */
export const ANO_INICIAL = 2026;

/** Outubro: o mês em que as duas ligas abrem a temporada. */
const MES_INICIO = 9;      // 0 = janeiro
const DIA_INICIO = 22;

const MESES = [
  'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
  'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro',
];
const DIAS = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];

/** O ano em que a temporada N começa. */
export const anoDaTemporada = (season) => ANO_INICIAL + (season - 1);

/** "2026/27" — como toda liga que atravessa o ano se chama. */
export function rotuloTemporada(season) {
  const a = anoDaTemporada(season);
  return `${a}/${String((a + 1) % 100).padStart(2, '0')}`;
}

/**
 * O dia da rodada.
 *
 * As rodadas são espalhadas pela janela da temporada regular: a NBA joga 82
 * em ~170 dias (a cada 2), o NBB joga 30 nos mesmos ~170 (a cada 5-6). O
 * espaçamento sai da divisão, então serve para qualquer formato que a liga
 * venha a ter, sem número escrito na mão.
 */
export function dataDaRodada(season, round, totalRodadas) {
  const inicio = new Date(anoDaTemporada(season), MES_INICIO, DIA_INICIO);
  const JANELA = 170;   // dias entre a primeira e a última rodada
  const passo = totalRodadas > 1 ? JANELA / (totalRodadas - 1) : 0;
  const d = new Date(inicio);
  d.setDate(d.getDate() + Math.round((round - 1) * passo));
  return d;
}

/** A data de um jogo dos playoffs: depois da temporada regular. */
export function dataDoPlayoff(season, totalRodadas, rodadaPlayoff = 1, jogo = 1) {
  const ultima = dataDaRodada(season, totalRodadas, totalRodadas);
  const d = new Date(ultima);
  // Uma semana de intervalo, e depois ~3 dias entre jogos da série.
  d.setDate(d.getDate() + 7 + (rodadaPlayoff - 1) * 18 + (jogo - 1) * 3);
  return d;
}

/** "sáb, 15 de novembro" */
export function porExtenso(d) {
  return `${DIAS[d.getDay()]}, ${d.getDate()} de ${MESES[d.getMonth()]}`;
}

/** "15/11/2026" */
export function curta(d) {
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
}

/** "15/11" — para tabelas, onde o ano se repete em toda linha. */
export function diaMes(d) {
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}`;
}
